import { render, staticRenderFns } from "./SLAReport.vue?vue&type=template&id=a4b7431c&scoped=true"
import script from "./SLAReport.vue?vue&type=script&lang=js"
export * from "./SLAReport.vue?vue&type=script&lang=js"
import style0 from "./SLAReport.vue?vue&type=style&index=0&id=a4b7431c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b7431c",
  null
  
)

export default component.exports